// extracted by mini-css-extract-plugin
export default {"container":"sendSmsCodeAgainForm-module__container__4Nk-a","actionItem":"sendSmsCodeAgainForm-module__actionItem__dvsEg","content":"sendSmsCodeAgainForm-module__content__Edh8c"};